import React from 'react';
import { css } from '@emotion/react';
import { Info } from '@material-ui/icons';
import { OnwardTooltip } from '@/styles/blocks';
import { colors } from '@/styles';
import { BulkCount, BulkDivider, BulkSpacer, BulkButtonPrimary, BulkButtonOutlined, ClearButton } from './blocks';

const BarButton = ({ button }) => {
    const rendered =
        button.variant === 'primary' ? (
            <BulkButtonPrimary disabled={button.disabled} onClick={button.onClick}>
                {button.label}
            </BulkButtonPrimary>
        ) : (
            <BulkButtonOutlined color={button.color} disabled={button.disabled} onClick={button.onClick}>
                {button.label}
            </BulkButtonOutlined>
        );

    if (!button.disabledReason) {
        return rendered;
    }
    // A disabled button fires no mouse events, so the tooltip has to hang off a wrapper.
    return (
        <OnwardTooltip title={button.disabledReason} placement="top">
            <span>
                {rendered}
                <Info
                    fontSize="small"
                    css={css`
                        color: ${colors.reds.primary};
                        vertical-align: middle;
                        margin-left: 4px;
                    `}
                />
            </span>
        </OnwardTooltip>
    );
};

// Renders a config-provided list of buttons. Used by both the sticky page bar (selection +
// persistent actions) and any inline bar. `buttons` = [{ label, variant, color, onClick, disabled,
// disabledReason }].
// The count/Clear only show when there is an active selection (persistent-only bars omit them).
const BulkActions = ({ count = 0, noun = 'item', buttons = [], onClear }) => (
    <>
        {count > 0 ? (
            <>
                <BulkCount>
                    <b>{count}</b> {noun}
                    {count === 1 ? '' : 's'} selected
                </BulkCount>
                <BulkDivider />
            </>
        ) : null}
        {buttons.map((button) => (
            <BarButton key={button.label} button={button} />
        ))}
        <BulkSpacer />
        {count > 0 && onClear ? <ClearButton onClick={onClear}>Clear</ClearButton> : null}
    </>
);

export default BulkActions;
